import LandingPage from './LandingPage';

export default LandingPage;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/index.js